/* Reducer LANG */

const saved = localStorage.getItem("lang")
const DEFAULT = saved ? saved : "ru"

const lang = (state = DEFAULT, action) => {

    switch (action.type) {

        case 'SET_LANG':
            const lang = action.payload
            localStorage.setItem("lang", lang)
            return lang

        default:
            return state
    }
}

export default lang
